import { track } from "../analytics";

/**
 * Function to show intercom message wizard on the app
 */
export const showMessenger = () => {
    track("Request help/intercom");
    window.Intercom("show");
};
